import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import { deleteUser } from 'store/adminPanel/actions';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';

const DeleteModal = ({ isVisible, setVisible, selectedUsers, setSelectedUsers}) => {
  const dispatch = useDispatch();
  
  const handleOk = () => {
    selectedUsers.map(item => dispatch(deleteUser(item)));
    setSelectedUsers([]);
    setVisible(false);
  };

  return (
    // <Modal
    //   isVisible={isVisible}
    //   Icon={WarningRed}
    //   onCancel={() => setVisible(false)}
    //   onOk={() => handleOk()}
    //   width={400}
    //   okText="Delete"
    // >
    //   <div className="invalid-modal__body">
    //     Είστε βέβαιοι ότι επιθυμείτε να διαγράψετε τους επιλεγμένους χρήστες;
    //   </div>
    // </Modal>
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      width={400}
      title={<h1 style={{color:"#EB5757", marginTop:"0.563rem", marginLeft:"1rem"}}>Delete</h1>}
      okText="Delete"
      footer={
        <div style={{display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px"}}>
          <Button
            onClick={() => setVisible(false)}
            className="default-button"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {setVisible(false); handleOk()}}
            className="primary-button"
          >
            Delete
          </Button>
        </div>
      }
      className={'invalid-modal'}
    >
      <div className="invalid-modal__body">
        Είστε βέβαιοι ότι επιθυμείτε να διαγράψετε τους επιλεγμένους χρήστες;
      </div>
    </Modal>
  );
};

export default DeleteModal;